import { makeStyles, Tooltip } from "@material-ui/core";
import React from "react";
import { slugForDestination } from "../destinations/destinations";
import useAccountMetadata from "../hooks/useAccountMetadata";
import { useDestinationMetadataManager } from "../hooks/useDestinationMetadataManager";
import { LoadedDestinationInfo } from "../types/global";
import { isAccountInHIPAAMode, isDestinationInHIPAAMode } from "../util";

import { ShieldCheckmarkIcon } from "./icons/themes/windows10";

const useStyles = makeStyles((theme) => ({
  tooltip: {
    marginLeft: theme.spacing(2),
  },
}));

export const HIPAAModeTooltip: React.FC<{ dest: LoadedDestinationInfo }> = ({
  dest,
}) => {
  const classes = useStyles();
  const accountMetadata = useAccountMetadata();
  const destinationMetadataManager = useDestinationMetadataManager();
  if (
    !accountMetadata ||
    !isAccountInHIPAAMode(accountMetadata) ||
    !isDestinationInHIPAAMode(dest) ||
    destinationMetadataManager.destinationIsWarehouse(slugForDestination(dest))
  ) {
    return null;
  }

  return (
    <Tooltip
      className={classes.tooltip}
      title="ID Masking and Allowlisting enabled."
    >
      <ShieldCheckmarkIcon />
    </Tooltip>
  );
};
